<div class="meal__container">
  <app-skeleton-loader width="150px" height="150px" borderRadius="6px" />
  <div class="meal__content">
    <div class="meal__info">
      <div class="meal__info__data">
        <app-skeleton-loader width="120px" height="24px" borderRadius="6px" />
        <div style="margin-top: 8px;">
          <app-skeleton-loader width="180px" height="16px" borderRadius="6px" />
        </div>
        <div style="margin-top: 4px;">
          <app-skeleton-loader width="150px" height="16px" borderRadius="6px" />
        </div>
      </div>
    </div>
    <div class="meal__actions">
      <app-skeleton-loader width="80px" height="22px" borderRadius="6px" />
      <app-skeleton-loader width="40px" height="40px" borderRadius="50%" />
    </div>
  </div>
</div>

